import fonts from './fonts'
import colors from './colors'

const title = {
    display: 'block',
    textAlign: 'center',
    fontSize: 34,
    fontWeight: 'bold',
}

const subtitle = {
    display: 'block',
    textAlign: 'right',
    fontWeight: 400,
    fontSize: 34,
    color: colors.yellow,
}

const body = {
    textAlign: 'center',
    color: colors.black,
    fontSize: 24,
}

const submitButton = {
    theme: 'shareModalButton',
    style: {
        marginTop: 31,
        boxShadow: '0 0.2em 0.4em 0 rgba(0, 0, 0, 0.5)',
        cursor: 'pointer',
    },
}

export default {
    title: title,
    desktopTitle: Object.assign({}, title, {
        fontSize: 24,
    }),
    subtitle: subtitle,
    desktopSubTitle: Object.assign({}, subtitle, {
        color: colors.black,
        fontSize: 10,
    }),
    body: body,
    registrationBody: Object.assign({}, body, {
        fontSize: 21,
        fontWeight: 600,
    }),
    submitButton: submitButton,
    submitDesktopButton: Object.assign({}, submitButton, {
        labelStyle: {
            fontSize: 14,
            fontWeight: 'lighter',
        },
    }),
}
